module.exports = __webpack_public_path__ + "img/hubspot.82c1aa9b.svg";